module.exports = __webpack_public_path__ + "static/media/smiley-blush.55d48c00.svg";